// src/pages/DepartamentosMudanzas.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaTruckMoving, FaClipboardCheck, FaChevronLeft, FaBell, FaRegClock, FaExclamationTriangle } from 'react-icons/fa';
import './DepartamentosDetalle.css';

const DepartamentosMudanzas = () => (
    <div className="departamentos-page">
        <div className="departamentos-container">
            <header className="departamentos-header">
                <div className="departamentos-header-icon">
                    <FaTruckMoving />
                </div>
                <div>
                    <h1>Mudanzas</h1>
                    <p>Consulta y atiende las solicitudes provenientes del módulo de permisos y accesos.</p>
                </div>
                <Link to="/administracion" className="departamentos-back-link">
                    <FaChevronLeft /> Regresar a administración
                </Link>
            </header>

            <section className="departamentos-content">
                <article className="departamentos-card">
                    <div className="departamentos-card-header">
                        <h2 className="section-title"><FaRegClock /> Flujo de autorización</h2>
                    </div>
                    <p className="help-text">Clasifica cada solicitud de mudanza según su avance y gestiona la coordinación con vigilancia.</p>
                    <div className="mudanza-grid">
                        <div className="status-card">
                            <h3><FaRegClock /> Pendientes por revisar</h3>
                            <p>Valida documentación, verifica adeudos y confirma fechas disponibles.</p>
                            <span className="badge">-- solicitudes</span>
                        </div>
                        <div className="status-card ok">
                            <h3><FaClipboardCheck /> Aprobadas</h3>
                            <p>Notifica a vigilancia y genera el pase de acceso temporal.</p>
                            <span className="badge">-- próximas</span>
                        </div>
                        <div className="status-card alert">
                            <h3><FaExclamationTriangle /> Observaciones</h3>
                            <p>Solicitudes con evidencia incompleta o pendientes de pago.</p>
                            <span className="badge">-- requieren acción</span>
                        </div>
                    </div>
                    <Link to="/admin/mudanzas" className="primary-button">
                        <FaTruckMoving /> Abrir módulo de mudanzas
                    </Link>
                </article>

                <article className="departamentos-card">
                    <div className="departamentos-card-header">
                        <h2 className="section-title"><FaClipboardCheck /> Integraciones clave</h2>
                    </div>
                    <div className="note-box">
                        <p>Sincroniza la información con el módulo de propietarios y de RFID para desactivar accesos automáticamente cuando la mudanza se completa.</p>
                        <div className="owner-links" style={{ marginTop: '12px' }}>
                            <Link to="/administracion/departamentos/identificacion" className="secondary-button">Ver propietarios</Link>
                            <Link to="/administracion/departamentos/rfid" className="secondary-button">Control RFID</Link>
                        </div>
                    </div>
                </article>

                <article className="departamentos-card">
                    <div className="departamentos-card-header">
                        <h2 className="section-title"><FaBell /> Notificaciones automáticas</h2>
                    </div>
                    <p className="help-text">Configura recordatorios al residente y vigilantes para preparar el día de la mudanza.</p>
                    <div className="note-box">
                        <p>Define mensajes prearmados para confirmar la recepción de la solicitud, la aprobación y la conclusión de la mudanza.</p>
                        <Link to="/admin/notificaciones/mudanzas" className="secondary-button">Configurar avisos</Link>
                    </div>
                </article>
            </section>
        </div>
    </div>
);

export default DepartamentosMudanzas;
